import React from 'react';
import { Sprout, Package, Truck } from 'lucide-react';
import './HowItWorks.css';
import { howItWorks } from '../mockData';

const iconMap = {
  1: Sprout,
  2: Package,
  3: Truck
};

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="how-it-works-section">
      <div className="container">
        <div className="section-header">
          <h2 className="heading-2">How It Works</h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)', marginTop: '1rem' }}>
            From farm to table in 3 simple steps
          </p>
        </div>
        <div className="steps-container">
          {howItWorks.map((step, index) => {
            const Icon = iconMap[step.step];
            return (
              <React.Fragment key={step.step}>
                <div className="step-card">
                  <div className="step-number">{step.step}</div>
                  <div className="step-icon">
                    <Icon size={40} strokeWidth={1.5} />
                  </div>
                  <h3 className="heading-3">{step.title}</h3>
                  <p className="body-medium" style={{ marginTop: '0.75rem' }}>{step.description}</p>
                </div>
                {index < howItWorks.length - 1 && (
                  <div className="step-connector">
                    <div className="connector-line"></div>
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
